import React from 'react';
import { confirmable } from 'react-confirm';
import { useTranslation } from 'react-i18next';
import StackedModal from './stacked_modal';

function LogoutDialog({ show, proceed, title, content }) {
  const { t } = useTranslation();

  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:button.logout')}
      content={content || t('common:confirmation.logout')}
      primaryAction={{
        content: t('common:button.logout'),
        onAction: () => {
          proceed(true);
        },
      }}
      onClose={() => {
        proceed(true);
      }}
    />
  );
}

export default confirmable(LogoutDialog);
